import { Route } from '@angular/router';
import { RoutingID } from '../../../../sb-routing-enum';
import { SbIcons } from '@ngx-seatback/icons';
import { InventoryWrapperComponent } from '../../../../../pages/inventory/inventory-wrapper/inventory-wrapper.component';

export const inventory: Route = {
  path: 'inventory-overview',
  title: 'nav.inventory.overview',
  data: {
    icon: SbIcons.checkList,
    breadcrumb: 'nav.inventory.overview',
    id: RoutingID.inventoryOverview,
  },
  children: [
    {
      path: '',
      component: InventoryWrapperComponent,
      data: {
        breadcrumb: '',
      },
    },
  ],
};
